export default __webpack_public_path__ + "static/media/Fierce Spirit_ Combusting Courage.0bf91280.png";